module.exports = __webpack_public_path__ + "static/media/img9.0ed224b8.jpg";